<template>
  <section class="uploadWordPage">
    <popup v-show="isShowUploadWord" bread="教材管理,课程管理,设置主题资料,上传字母" title="上传字母" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'上传字母'">
        <h3 class="group-tit">字母资料</h3>
        <commonUploadWord ref="ref_commonUploadWord" :key="timestamp" label-name="字母" :max-number="(30-currentNumber)" code="zm" @formChange="commonUploadWordChange" />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonUploadWord from '../components/commonUploadWord'
import { addBasicMeans } from '@api/courseManagement/api_setThemeData'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  components: {
    commonUploadWord
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadWord: false,
      commonUploadForm: {}
    }
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadWord = true
    }
  },
  created () {

  },
  methods: {
    // 返回
    popup_back () {
      this.isShowUploadWord = false
      // this.$emit('resetFetchData')
    },
    commonUploadWordChange (form) {
      this.commonUploadForm = form
    },
    saveUploadWord () {
      if (!this.$refs.ref_commonUploadWord.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      for (const item of this.commonUploadForm.wordList) {
        params.push({
          wordName: item.wordName,
          cardChartName: item.img[0].paramsFileName,
          cardChartPath: item.img[0].paramsUrl,
          pronunciationName: item.voice[0].paramsFileName,
          pronunciationPath: item.voice[0].paramsUrl,
          mouthShapeName: item.video[0].paramsFileName,
          mouthShapePath: item.video[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          meansType: 9,
          basicCode: 'LETTER'
        })
      }
      addBasicMeans({ basicMeansList: params }).then(res => {
        this.isShowUploadWord = false
        this.$emit('resetFetchData')
      })
    }

  }
}
</script>

<style lang='scss'>
.uploadWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
